const enGB = {
  loading: 'Loading',
  progressBarCompleted: 'Completed',
  progressBarCurrent: 'Current',
};

export default enGB;
